import ApiModel     from './globals/ApiModel';
import { computed } from 'mobx';

export default class ProviderShowCategoryModel extends ApiModel {
  static get path() {
    return '/backend/provider_show_categories/{?id}';
  }

  @computed
  public get providerShowCategoryName() {
    return this.get('name');
  }
}
